import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 12h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 18V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 18V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "19", cy: "16", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 10c-2 2-3 3.5-3 6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Heading6";
const Heading6 = memo(themed(Icon));
export {
  Heading6
};
//# sourceMappingURL=heading-6.js.map
